<div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid">
    <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__body">
              <kt-promotion-application-shared></kt-promotion-application-shared>
        </div>
    </div>
</div>
